import { render, staticRenderFns } from "./Interaction.vue?vue&type=template&id=251d2b9f&"
import script from "./Interaction.vue?vue&type=script&lang=js&"
export * from "./Interaction.vue?vue&type=script&lang=js&"
import style0 from "./Interaction.vue?vue&type=style&index=0&id=251d2b9f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VRow})
